var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogoLightmodeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.9 294.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8b22b;\n      }\n\n      .cls-2 {\n        fill: #49224c;\n      }\n\n      .cls-3 {\n        fill: #4e1c4e;\n      }\n\n      .cls-4 {\n        fill: #e1b34a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 144.8,
    cy: 146.7,
    rx: 126.5,
    ry: 127
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.4,139.7c-2.3,2-3.4,4.3-3.4,7.6s1.3,5.4,4.2,7.2c2.3,1.6,8.7,4.3,25.3,8.4.3,0,.4,0,.5.1v-23.9c-5.2-1.7-10.6-2.5-16-2.5s-8.1,1-10.6,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161,196.1v-26c-.8-.1-1.4-.4-2.2-.7-14.2-3.5-23.2-6.5-27.4-9.3-1-.7-2.1-1.6-2.9-2.4v28.4c4.6,1.6,9.6,3,15.1,4.4,7.4,1.8,13,3.7,17.2,5.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.5,110.6c.7,1.7,1,3.5,1,5.4v19.9s1-1,1.6-1.4c3.6-3,8.7-4.6,14.9-4.6s10.7.8,16,2.2v-16.1c0-2.2.5-4.3,1.4-6.2-5.5-1-10.9-1.7-16.4-1.7s-12.9.8-18.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.6,219.6h4.3c7.7,0,14.1-6.3,14.1-14.1v-1.8c-2.7-1.6-8.2-3.8-18.9-6.4-4.8-1.2-9.4-2.5-13.6-3.8v12c0,7.7,6.3,14.1,14.1,14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.4,102h13c3.3,0,6.3,1,8.6,3,6.9-2.4,14.6-3.5,22.9-3.5s14.3.9,21.6,2.6c2.1-1.3,4.7-2.1,7.4-2.1h13c7.7,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-86.7c-7.7,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.2,189.5c-4.8,0-7.4-2.6-7.4-7.4v-61.9h-17.5c-4.8,0-7.4-2.7-7.4-7.4v-2.6c0-4.8,2.6-7.4,7.4-7.4h53.3c4.8,0,7.4,2.6,7.4,7.4v2.6c0,4.7-2.6,7.4-7.4,7.4h-17.5v61.9c0,4.8-2.6,7.4-7.4,7.4h-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.1,90.5c0-5.8,4.8-10.3,10.5-10.3s10.4,4.5,10.4,10.3-4.7,10.3-10.4,10.3-10.5-4.5-10.5-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.9,189.5c-4.6,0-7.1-2.5-7.1-6.9v-47.5c0-4.5,2.5-6.9,7.1-6.9h3.3c4.6,0,7.1,2.5,7.1,6.9v47.5c0,4.5-2.5,6.9-7.1,6.9h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506,158.8c0,18-12.2,32-29.1,32s-15.1-3.5-19.5-8.4v31.2c0,4.5-2.5,6.9-7.1,6.9h-3.3c-4.6,0-7.1-2.5-7.1-6.9v-78.5c0-4.5,2.5-6.9,7.1-6.9h3.3c4.6,0,7.1,2.5,7.1,6.9v.2c4.3-5,10.7-8.4,19.5-8.4,17,0,29.1,13.9,29.1,31.9ZM488.5,158.8c0-9.3-6.8-16.5-15.6-16.5s-15.5,7.2-15.5,16.5,6.8,16.6,15.5,16.6,15.6-7.1,15.6-16.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.3,186.3c-3.7-1.7-4.1-5.1-2.1-8.8l1.1-1.7c1.7-3.2,4.6-3.6,7.8-2,4.5,2.1,9.3,3.6,13.5,3.6,7.1,0,9.7-2.2,9.7-5.6,0-10-32.7-3.5-32.7-26.3s11.2-18.6,24.6-18.6,12.8,1.1,18.2,3.5c3.8,1.7,4.5,5,2.4,8.8l-1,1.7c-1.9,3.1-4.6,3.6-7.9,2.1-3.5-1.6-7.1-2.7-10.5-2.7-5.5,0-8.4,2.1-8.4,5.1,0,9.8,32.7,3.8,32.7,26.4s-9.9,19-26.3,19-15.1-1.5-21-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.8,164h-38.8c2,8.6,8.8,13.4,16.5,13.4s9.2-2,13-5c2.9-2.1,5-1.9,7.3,1.6l1.6,2.6c1.7,2.7,1.5,5.6-1.6,7.9-5,3.7-12.2,6.2-20.7,6.2-18.2,0-33.4-12.2-33.4-31.9s13.5-32,32.1-32,31,10.8,31,29.9-2.9,7.2-7.1,7.2ZM591,153.2h29.5c-1.6-8.4-7.3-13-14.6-13s-13.1,4.7-14.9,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.9,132.2v6.4c0,3.6-2.1,5.7-6.1,5.7-9.2,0-15.5,6-15.5,19.3v18.8c0,4.5-2.5,6.9-7.1,6.9h-3.3c-4.6,0-7.1-2.5-7.1-6.9v-47.5c0-4.5,2.5-6.9,7.1-6.9h3.3c4.6,0,7.1,2.5,7.1,6.9v2.1c4.1-7.2,10.2-10.3,16.6-10.3s5,1.9,5,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.9,189.5c-4,0-6.4-1.7-7.8-5.6l-17.5-47.7c-1.9-5,.4-8.1,5.6-8.1h4.1c4.1,0,6.7,2,7.8,6l10,32.1,2,6.9h.4l1.7-6.9,9.9-32.1c1.2-4,3.7-6,7.9-6h4.1c5.1,0,7.3,3.1,5.5,8.1l-17.4,47.7c-1.4,3.8-3.8,5.6-7.8,5.6h-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814.7,164h-38.8c2,8.6,8.8,13.4,16.5,13.4s9.2-2,13-5c2.9-2.1,5-1.9,7.3,1.6l1.6,2.6c1.7,2.7,1.5,5.6-1.6,7.9-5,3.7-12.2,6.2-20.7,6.2-18.2,0-33.4-12.2-33.4-31.9s13.5-32,32.1-32,31,10.8,31,29.9-2.9,7.2-7.1,7.2ZM775.9,153.2h29.5c-1.6-8.4-7.3-13-14.6-13s-13.1,4.7-14.9,13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogoLightmodeSvg);
export default __webpack_public_path__ + "static/media/full-logo-lightmode-svg.65c0a0391cbf41b94c78381630cdf9a6.svg";
export { ForwardRef as ReactComponent };